export default "__VITE_ASSET__CoP70Ap8__"